export default __webpack_public_path__ + "static/Data-Aggregation-2182ab8132f3d3581cbf6868910fd7e1.png";